import {createSlice} from  '@reduxjs/toolkit';

const initialLoginState = {
    isloading:false,
    islogIn:false, 
    error:''
};

const loginSlice = createSlice({
    name:'login',
    initialState:initialLoginState,
    reducers:{
        loginPending: (state) => {
            state.isloading = true;
        },
        loginSuccess: (state) => {
            state.isloading = false;
            state.islogIn= true;
            state.error= 'Success Logged In';
        },
        loginFail: (state, {payload}) => {
            state.isloading = false;
            state.islogIn=false;
            state.error= 'Invalid Email or Password!';
        },
        logout: (state) => {
            state.isloading = false;
            state.islogIn=false;
            state.error= 'Success Logged Out';
        }
    }
});

const {reducer, actions} = loginSlice;
export const {loginPending, loginSuccess, loginFail, logout} = actions;

export default reducer;